module.exports = __webpack_public_path__ + "img/your-answer.b3776e2c.svg";